import { Auth } from 'aws-amplify';

const signupAuth = async user => {
  const newUser = await Auth.signUp({
    username: user.email,
    password: user.password,
    attributes: {
      name: user.name,
      phone_number: user.phoneNumber,
    },
  });
  return newUser;
};

export default signupAuth;



// WEBPACK FOOTER //
// ./src/services/auth/signupAuth.js